import school from './school/ducks/school';
import schoolList from './school/ducks/schoolList';

import detailBook from './books/ducks/bookInfo'; // end


import schoolRecommendBooks from './recommend/ducks/schoolRecommendBooks'; // end
import schoolRecommendList from './recommend/ducks/schoolRecommendList'; // end

import themeRecommendList from './recommend/ducks/themeRecommendList'; // end
import userRecommend from './recommend/ducks/userRecommend'; // end

import swapPuzzle from './authorMeeting/ducks/swapPuzzle'; // end

import auth from './user/auth/ducks/auth'; // end
import wishBooks from './user/ducks/wishBooks'; // end

import notificationCount from './notification/ducks/notificationCount'; // end
import notificationModal from './notification/ducks/notificationModal'; // end

import userFollowingList from './user/ducks/userFollowingList'; // end
import userFollowerList from './user/ducks/userFollowerList' // end


import readingTest from './readingTest/ducks/readingTest';
import readingTestResult from './readingTest/ducks/readingTestResult';

import clipartCategory from './readingPicture/ducks/clipartCategory';
import clipartList from './readingPicture/ducks/clipart';
import backgroundList from './readingPicture/ducks/background';

//import config from './common/ducks/config';
import config from 'bf-library/src/ducks/config';

import { configureStore } from '@reduxjs/toolkit';

const store = configureStore({
    reducer: {
        config,
        school, schoolList,

        schoolRecommendList,
        schoolRecommendBooks,
        themeRecommendList,

        detailBook,

        userFollowerList,
        userFollowingList,


        notificationCount,
        notificationModal,

        swapPuzzle,

        userRecommend,
        wishBooks,
        auth,

        readingTest,
        readingTestResult,

        clipartCategory,
        clipartList,
        backgroundList,

    }
});
export default store;